module.exports = __webpack_public_path__ + "img/send-icon.4f56a6dd.svg";